define(['jquery', 'uiComponent'], function ($, Component) {
    'use strict';

    return Component.extend({
        defaults: {
            parentSelector: '',
            // Skip first child since the browser starts there by default
            targetSelector: '.current:not(:first-child)'
        },

        getScrollOffset: function (target) {
            if (!target.length) {
                return 0;
            }

            // Get left offset from center of target and offset it by half the width of the viewport
            return target.offset().left + (target.width() / 2) - ($(window).width() / 2);
        },

        initialize: function (config, element) {
            this._super(config, element);

            const parent = this.parentSelector? $(this.parentSelector) : $(element);
            const offset = this.getScrollOffset(parent.find(this.targetSelector));
            if (offset) {
                // Let the browser decide if the viewport needs to shift
                parent.scrollLeft(offset);
            }
        }
    });
});
